import * as React from 'react';
import { useEffect, useState } from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { AtendimentosSSEService } from "../../../services/AtendimentosSSEService";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { TableContainer } from "@material-ui/core";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@mui/material/TableRow";
import Table from "@material-ui/core/Table";
import Paper from "@mui/material/Paper";
import { formatDateImage, formatDateToBR, formatHoursToBRWithoutSeconds } from "../../../../../utils/time";
import { cnpjMask, cpfMask, formatDefaultValueSelect } from "../../../../../utils/mask";
import { capitalizeWords, removeConsecutiveDuplicatesWord, removeEmpty } from "../../../../../utils/utils";
import { useLocation } from "react-router-dom";

const VISITA_LABEL = {
    PRIMEIRA_VISITA: 1,
    SEGUNDA_VISITA: 2,
};

const styleTableCell = {
    color: '#00CCFF',
    fontWeight: 'bold'
}
export default function GaleriaImagens() {

    const [images, setImages] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(0);
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedImageInfo, setSelectedImageInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [itemList, setItemList] = useState(null);

    const location = useLocation();
    const filterData = location?.state?.filters;

    const fetchImages = async () => {
        const params = {
            page,
            linesPerPage: 10,
            orderBy: 'id',
            direction: 'DESC'
        }
        filterData.foto = true;
        const result = await AtendimentosSSEService.findAll(params, removeEmpty(filterData));
        setItemList(result?.content);
        const newImages = result?.content.flatMap(i => i?.imagens);
        console.log('newImagens', newImages);
        setImages(prevState => [...prevState, ...newImages]);
        if (page === result?.totalPages) {
            setHasMore(false);
        }
        setIsLoading(false);
    };


    useEffect(() => {
        fetchImages()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (hasMore && page > 0) {
            fetchImages();
        }
        // eslint-disable-next-line
    }, [page]);


    const fetchMoreData = async () => {
        setIsLoading(true);
        setPage(prevState => prevState + 1);
    };

    const handleCloseModal = () => {
        setModalIsOpen(false);
        setSelectedImage(false)
    }

    const handleOpenModal = (image) => {
        const infoImagem = itemList.find(t => t?.imagens?.find(i => image.id === i.id))
        console.log('infoImagem', infoImagem);
        setSelectedImage(image)
        setSelectedImageInfo(infoImagem)
        setModalIsOpen(true);
    }

    useEffect(() => {
        const handleDocumentScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            if (!isLoading && hasMore && scrollTop + windowHeight >= documentHeight - 20) {
                setIsLoading(true);
                fetchMoreData();
            }
        };
        window.addEventListener('scroll', handleDocumentScroll);
        return () => window.removeEventListener('scroll', handleDocumentScroll);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const container = document.querySelector('.container');
            const scrollTop = container.scrollTop;
            const windowHeight = container.clientHeight;
            const scrollHeight = container.scrollHeight;

            if (!isLoading && hasMore && scrollTop + windowHeight >= scrollHeight - 20) {
                setIsLoading(true);
                fetchMoreData();
            }
        };
        const container = document.querySelector('.container');
        if (container) {
            container.addEventListener('scroll', handleScroll);
            return () => container.removeEventListener('scroll', handleScroll);
        }
        // eslint-disable-next-line
    }, []);

    const ModalAtendimentoImagem = ({open, onClose}) => {
        if (!selectedImage) return null

        console.log('selectedImageInfo', selectedImageInfo);
        console.log('selectedImage', selectedImage);

        return (
            <Dialog
                fullWidth={true}
                maxWidth={"lg"}
                open={open}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow style={styleTableCell}>
                                    <TableCell style={styleTableCell}>Cód</TableCell>
                                    <TableCell style={styleTableCell} align="right">Data</TableCell>
                                    <TableCell style={styleTableCell} align="right">Hora</TableCell>
                                    <TableCell style={styleTableCell} align="center">CPF</TableCell>
                                    <TableCell style={styleTableCell} align="center">CNPJ</TableCell>
                                    <TableCell style={styleTableCell} align="center">Porte</TableCell>
                                    <TableCell style={styleTableCell} align="center">UF</TableCell>
                                    <TableCell style={styleTableCell} align="center">Cidade</TableCell>
                                    <TableCell style={styleTableCell} align="center">Agente</TableCell>
                                    <TableCell style={styleTableCell} align="left">Interação</TableCell>
                                    <TableCell style={styleTableCell} align="left">Visita</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                                    <TableCell component="th" scope="row">{selectedImageInfo?.id}</TableCell>
                                    <TableCell
                                        align="right">{formatDateToBR(selectedImageInfo?.dataAtendimento)}</TableCell>
                                    <TableCell
                                        align="right">{formatHoursToBRWithoutSeconds(selectedImageInfo?.dataAtendimento)}</TableCell>
                                    <TableCell
                                        align="center">{cpfMask(selectedImageInfo?.administrador?.cpf)}</TableCell>
                                    <TableCell
                                        align="center">{cnpjMask(selectedImageInfo?.empreendedor?.cnpj)}</TableCell>
                                    <TableCell
                                        align="center">{selectedImageInfo?.empreendedor?.dadoComplementar?.porte?.sigla ?? selectedImageInfo?.empreendedor?.porteApp?.sigla}</TableCell>
                                    <TableCell align="center">{selectedImageInfo?.empreendedor?.uf}</TableCell>
                                    <TableCell
                                        align="center">{selectedImageInfo?.empreendedor?.cidade?.nome}</TableCell>
                                    <TableCell
                                        align="center">{capitalizeWords(removeConsecutiveDuplicatesWord(selectedImageInfo?.nomeAtendente))}</TableCell>
                                    <TableCell
                                        align="left">{formatDefaultValueSelect(selectedImageInfo?.tipoInteracao)}</TableCell>
                                    <TableCell align="left">{VISITA_LABEL[selectedImageInfo?.visita]}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>


                    <div style={{display: 'flex', gap: '20px'}}>
                        <ImageList cols={1} gap={8} style={{paddingTop: 20}}>
                            <ImageListItem style={{width: '785px', height: '470px', marginBottom: '22px'}}>
                                <img
                                    src={`${selectedImage.urlConteudo}?w=785&h=443&fit=crop&auto=format`}
                                    loading="lazy"
                                    alt={''}
                                    style={{
                                        borderRadius: '12px',
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                        backgroundColor: 'black'
                                    }}
                                />
                                <p style={{
                                    marginTop: '10px',
                                    textAlign: 'center'
                                }}>Data: <strong>{formatDateImage(selectedImage.nome)}</strong></p>
                            </ImageListItem>
                        </ImageList>

                        {
                            !!selectedImageInfo?.imagens?.filter?.(i => i.id !== selectedImage.id) && (
                                <ImageList cols={1} gap={8} style={{padding: 6}}>
                                    {
                                        selectedImageInfo?.imagens?.filter?.(i => i.id !== selectedImage.id)?.map((item) => (
                                            <ImageListItem style={{width: '250px', height: '150px', marginBottom: '22px'}}>
                                                <img
                                                    onClick={() => setSelectedImage(item)}
                                                    src={`${item?.urlConteudo}`}
                                                    loading="lazy"
                                                    alt={''}
                                                    style={{
                                                        borderRadius: '12px',
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover'
                                                    }}
                                                />
                                            </ImageListItem>
                                        ))
                                    }
                                </ImageList>
                            )
                        }
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Fechar</Button>
                </DialogActions>
            </Dialog>
        )
    }


    return (
        <>
            <div>
                <ImageList cols={4} gap={8} style={{padding: 20}}>
                    {images.map((imagem, index) => {
                        return (
                            <ImageListItem key={index} style={{width: '250px', height: '150px', marginBottom: '22px'}}>
                                <img
                                    onClick={() => handleOpenModal(imagem)}
                                    src={`${imagem?.urlConteudo}`}
                                    loading="lazy"
                                    alt={''}
                                    style={{borderRadius: '12px', width: '100%', height: '100%'}}
                                />
                            </ImageListItem>
                        )
                    })}
                </ImageList>
            </div>
            <ModalAtendimentoImagem open={modalIsOpen} onClose={handleCloseModal}/>
        </>
    );
}